import Loadable from '@townsquare/loadable';

// TODO: this likely isnt the right import
export const StudioApp = Loadable({
  loader: async () => import(/* webpackChunkName: "studio-app-entry" */ './Studio'),
  loading: () => null,
});
